import { forwardRef } from 'react';
import { UPLOAD_ACCEPT } from './api';

/** What a workspace file picker offers: every type an upload is admitted with. */
export const WORKSPACE_UPLOAD_ACCEPT = `${UPLOAD_ACCEPT},application/pdf,text/plain,text/markdown,text/csv,application/json`;

interface WorkspaceUploadInputProps {
  label: string;
  disabled: boolean;
  testId?: string;
  onFiles: (files: FileList) => void | Promise<void>;
}

export const WorkspaceUploadInput = forwardRef<HTMLInputElement, WorkspaceUploadInputProps>(
  function WorkspaceUploadInput({ label, disabled, testId, onFiles }, ref) {
    return (
      <input
        ref={ref}
        className="ws-sr-only"
        type="file"
        accept={WORKSPACE_UPLOAD_ACCEPT}
        multiple
        disabled={disabled}
        tabIndex={-1}
        aria-label={label}
        data-testid={testId}
        onChange={(event) => {
          if (event.target.files?.length) void onFiles(event.target.files);
          event.target.value = '';
        }}
      />
    );
  },
);
